export enum LicenseType {
  None = 'None',
  STD = 'STD',
  STDPlus = 'STD+',
  PREM = 'PREM',
  JDG = 'JDG',
  FREE = 'FREE',
}
